import { IActionContext } from '@msdyn365-commerce/core-internal';

export const GetCategoryIdFromUrl = (context: IActionContext): number => {
    const categoryId =
        (context.requestContext.query && context.requestContext.query['categoryId'] && +context.requestContext.query['categoryId']) || 0;
    return categoryId;
};
export const GetQeuryFromUrl = (context: IActionContext): string => {
    const query = (context.requestContext.query && context.requestContext.query['q'] && context.requestContext.query['q']) || '';
    return query;
};
export const GetSearchTermFromUrl = (context: IActionContext): string => {
    const searchTerm =
        (context.requestContext.query && context.requestContext.query['search_term'] && context.requestContext.query['search_term']) || '';
    return searchTerm;
};
export const GetWebgroupIdFromUrl = (context: IActionContext): string => {
    const webgroupId =
        (context.requestContext.query && context.requestContext.query['webgroupId'] && context.requestContext.query['webgroupId']) || '';
    return webgroupId;
};
